<template>
  <div>
    <portal to="inputs-grupo-filial">
      <div class="d-flex align-center">
        <SysGrupoAutocomplete
          v-model="grupos"
          label="Grupos de compras"
          outlined
          dense
          dark
          multiple
          ocultar_grupos_todos
          :auto_selecao_grupos="true"
          class="h-40px w-250"
        />
      </div>
    </portal>

    <div class="px-3 bg-gray-200" style="padding: 1px 0">
      <v-icon size="18">$StoreSearch</v-icon>
      <span class="ml-1 font-15 font-weight-medium">Diagnóstico / {{ NOME_CLIENTE }}</span>
    </div>

    <v-tabs v-model="tab_ativo" centered>
      <v-tab>Curvas cruzadas</v-tab>
      <v-tab>Slow-no moving</v-tab>
      <v-tab>Excesso de Estoque</v-tab>
      <v-tab>Clientes</v-tab>
      <v-tab>Análise Qualitativa</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab_ativo">
      <v-tab-item>
        <CurvasCruzadas />
      </v-tab-item>

      <v-tab-item>
        <SlowNoMoving />
      </v-tab-item>

      <v-tab-item>
        <ExcessoEstoque />
      </v-tab-item>

      <v-tab-item>
        <Clientes />
      </v-tab-item>

      <v-tab-item>
        <AnaliseEstoque />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import {primeiraLetraMaiuscula} from "@/helpers";
import CurvasCruzadas from './CurvasCruzadas/Index.vue'
import SlowNoMoving from "@/components/Diagnostico/SlowNoMoving/Index.vue";
import ExcessoEstoque from "@/components/Diagnostico/ExcessoEstoque/Index.vue";
import SysGrupoAutocomplete from "@/components/utils/crud/SysGrupoAutocomplete.vue";
import Clientes from "@/components/Diagnostico/Clientes/Index.vue";
import AnaliseEstoque from "@/components/Diagnostico/AnaliseEstoque/Index.vue";

export default {
  name: "Index",
  components: {
    Clientes,
    SysGrupoAutocomplete,
    ExcessoEstoque,
    SlowNoMoving,
    CurvasCruzadas,
    AnaliseEstoque
  },
  data: () => ({
    tab_ativo: null,
    grupos: [],
    empresa_cliente: localStorage.empresa,
    timer_mudar_grupos: null
  }),
  computed: {
    NOME_CLIENTE() {
      return primeiraLetraMaiuscula(this.empresa_cliente);
    },
    GRUPO_COMPRAS() {
      return this.$store.getters['usuario/getGrupoCompras'];
    }
  },
  watch: {
    grupos() {
      clearTimeout(this.timer_mudar_grupos);
      this.timer_mudar_grupos = setTimeout(this.setFiltroGruposStore, 2000);
    }
  },
  methods: {
    setFiltroGruposStore() {
      this.$store.dispatch("filtrosUniversalAvancado/filtros_grupos", this.grupos);
      this.$store.dispatch("filtrosProdutosDiagnostico/filtrosGrupos", this.grupos);
    }
  }
}
</script>

<style scoped>

</style>
